































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalProcedimentosVinculadosIncluir extends Vue {
  $refs: {
    formProcedimentos: any
  }

  formRules = {
    valid: false,
    codigoTuss: [(v: any) => !!v || 'O código é obrigatório.'],
  }

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalAdd() { return this.getRegrasDeCalculoStore.modal.procedimentosVinculadosIncluir }
  set showModalAdd(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentosVinculadosIncluir', value }) }

  get codigoTuss() { return this.getRegrasDeCalculoStore.codigoTuss }
  set codigoTuss(value: any) {
    const sanitizedValue = String(value || '').replace(/[^a-zA-Z0-9]/g, '')
    this.getRegrasDeCalculoStore.setCodigoTuss(sanitizedValue)
  }

  get isEditMode() { return this.getRegrasDeCalculoStore.mode }

  async addProcedimento() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.formProcedimentos.validate()) {
      this.loadingAddRegraCalculo = false
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Preencha os campos obrigatórios.',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }
    const request = await this.getRegrasDeCalculoStore.addProcedimentoVinculado()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.showModalAdd = false
  }

  @Watch('showModalAdd')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.codigoTuss = 0
      this.$refs.formProcedimentos.resetValidation()
    }
  }

  async mounted() {
    await this.getRegrasDeCalculoStore.getFuncoesProcedimento()
    await this.getRegrasDeCalculoStore.getFontesPagadoras()
  }
}
